import {
  getCurrentUgcUserEmail,
  uploadUgcFileToS3,
} from "./ugcTesting";

const UGC_BUCKET_BASE = "https://choirplayerugc.s3.amazonaws.com/ugc-uploads";
const USER_SETLISTS_FILENAME = "user-setlists.json";

let doprint = false;
// let doprint = true;


export function getUserSetlistsS3UrlForEmail(email) {
  return `${UGC_BUCKET_BASE}/${encodeURIComponent(email)}/${USER_SETLISTS_FILENAME}`;
}

export function getCurrentUserSetlistsS3Url() {
  return getUserSetlistsS3UrlForEmail(getCurrentUgcUserEmail());
}

export async function fetchUserSetlistsFromS3(email = getCurrentUgcUserEmail()) {
  const baseUrl = getUserSetlistsS3UrlForEmail(email);
  const url = `${baseUrl}${baseUrl.includes("?") ? "&" : "?"}cb=${Date.now()}`;

  if (doprint) console.log("[SETLISTS S3] fetching user setlists =", url);

  const response = await fetch(url, {
    cache: "no-store",
  });

  if (!response.ok) {
    if (response.status === 403 || response.status === 404) {
      if (doprint) console.log("[SETLISTS S3] no remote setlists yet", {
        email,
        status: response.status,
      });

      return [];
    }

    throw new Error(`Could not fetch user setlists from S3: ${response.status}`);
  }

  const json = await response.json();

  const setlists = Array.isArray(json)
    ? json
    : Array.isArray(json?.setlists)
      ? json.setlists
      : [];

  if (doprint) console.log("[SETLISTS S3] fetched user setlists =", {
    email,
    count: setlists.length,
    titles: setlists.map((setlist) => setlist.title),
  });

  return setlists;
}

export async function uploadUserSetlistsToS3(setlists, email = getCurrentUgcUserEmail()) {
  const safeSetlists = Array.isArray(setlists) ? setlists : [];

  const payload = {
    version: 1,
    updatedAt: new Date().toISOString(),
    userEmail: email,
    setlists: safeSetlists,
  };

  const blob = new Blob(
    [JSON.stringify(payload, null, 2)],
    { type: "application/json" }
  );

  const filename = `${email}/${USER_SETLISTS_FILENAME}`;

  if (doprint) console.log("[SETLISTS S3] uploading user setlists =", {
    filename,
    count: safeSetlists.length,
    titles: safeSetlists.map((setlist) => setlist.title),
  });

  return uploadUgcFileToS3(blob, filename, "application/json");
}

